import s from './calendar-header.module.scss';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const CalendarHeader = ({
  viewMode,
  currentMonth,
  weekCalendarDays,
  onPrev,
  onNext,
}) => {
  if (viewMode === 'month') {
    return (
      <div className={s.calendarHeader}>
        <button
          className={s.navButton}
          onClick={onPrev}
          aria-label="Предыдущий месяц"
          type="button"
        >
          <IconChevronLeft size={20} />
        </button>
        <span className={s.calendarTitle}>
          <span className={s.monthName}>
            {format(currentMonth, 'LLLL', { locale: ru })}
          </span>
          <span className={s.yearName}>{format(currentMonth, 'yyyy')}</span>
        </span>
        <button
          className={s.navButton}
          onClick={onNext}
          aria-label="Следующий месяц"
          type="button"
        >
          <IconChevronRight size={20} />
        </button>
      </div>
    );
  }

  return (
    <div className={s.calendarHeader}>
      <button
        className={s.navButton}
        onClick={onPrev}
        aria-label="Предыдущая неделя"
        type="button"
      >
        <IconChevronLeft size={20} />
      </button>
      <span className={s.calendarTitle}>
        {format(weekCalendarDays[0], 'd MMMM', { locale: ru })} -{' '}
        {format(weekCalendarDays[6], 'd MMMM', { locale: ru })}
      </span>
      <button
        className={s.navButton}
        onClick={onNext}
        aria-label="Следующая неделя"
        type="button"
      >
        <IconChevronRight size={20} />
      </button>
    </div>
  );
};
